import styles from "./bloggen.module.css"
import gStyles from "../../components/PageEdit.module.css"
import { FaPlus,FaPencilAlt,FaMinus } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";
import { useEffect, useState } from "react";
import EditAuthor from "../../util/edit-author";
import axios from 'axios'
import { useNavigate } from "react-router-dom";

export default function Bloggen() {

    const API_BASE =
        process.env.NODE_ENV === "development"
          ? "http://localhost:3000"
          : "https://api.hillerodfrimenighed.dk";

    const [blogs, setBlogs] = useState(null)
    const [loading, setLoading] = useState(true);
    const [author, setAuthor] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
            async function loadBlogs(){
                try{
                    const res = await fetch(`${API_BASE}/blog/`, {
                        headers: { "Content-Type": "application/json" },
                      });
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    const data = await res.json();
                    setBlogs(data);
                } catch (e) {
                    console.log(e.message || "Kunne ikke hente blogindlæg");
                } finally {
                    setLoading(false);
                }
            }
            loadBlogs();
        }, [API_BASE])

    function formatDate(ts) {
        const d = new Date(ts); // works for "YYYY-MM-DD HH:mm:ss" or ISO
        if (isNaN(d)) return null;
        return d.toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });
        };
    
    async function deleteBlog(id) {
        console.log(id)
        const ok = window.confirm("Er du sikker på, at du vil slette dette blogindlæg?");
        if (ok) {
            try {
                // Send DELETE request to backend
                const res = await axios.delete(`${API_BASE}/blog/page/${id}`, {
                withCredentials: true, // ✅ important if your backend uses auth cookies
                });

                if (res.status === 200) {
                    window.location.reload(); 
                }
            } catch (error) {
                console.error("Error deleting blog:", error);
                alert(
                `Fejl under sletning: ${
                    error.response?.data?.error || "Kunne ikke slette blogindlægget."
                }`
                );
            }
        }
    }

    function editBlogReroute(id) {
        navigate(`/edit-blog/${id}`);
    }

    if (loading) return <h2>Loading...</h2>

    return (
        <div className={styles.section}>
            <h1>Bloggen</h1>
            <div className={gStyles.pageInfoEdit}>
                <h2>Opret en ny blog</h2>
                <a href="/edit-blog/0"><FaPlus className={styles.plus}/></a>
            </div>
            <div className={gStyles.pageInfoEdit}>
                <h2>Forfattere</h2>
                <p>Tilføj nye forfattere eller rediger de eksisterende.</p>
                {author === null ? (
                    // Show the plus button when no author is being edited/created
                    <FaPlus
                        className={styles.plus}
                        onClick={() => setAuthor(0)} // 0 = new author mode
                    />
                    ) : (
                    // Once plus is clicked (author = 0 or existing id), show EditAuthor instead
                    <div style={{display:'flex', flexFlow:'column', width:'100%', alignItems:"center"}}>
                        <FaMinus
                            className={styles.plus}
                            onClick={() => setAuthor(null)} // null = no edit
                            style={{marginBottom:'30px'}}
                        />
                        <EditAuthor author_id={author} onAuthorChange={setAuthor} />
                    </div>
                )}
            </div>
            <h2>Tidliger blogopslag</h2>
            {(blogs?.length ?? 0) === 0 ? (
                <p>Ingen blogindlæg endnu.</p>
                ) : (
                blogs.map((b) => 
                <div key={b.blog_id} className={gStyles.pageInfoEdit}>
                    <p>{formatDate(b.blog_created_at)}</p>
                    <h3>{b.title}</h3>
                    <p>Af {b.author_name}</p>
                    <div className={styles.actionBox}>
                        <FaPencilAlt className={gStyles.iconBnt} onClick={() => editBlogReroute(b.blog_id)}/>
                        <TiDelete className={gStyles.deleteIcon} style={{fontSize: "35px"}} onClick={() => deleteBlog(b.blog_id)}/>
                    </div>
                </div>)
                )}
        </div>
    );
}